import { Height, Room } from '@mui/icons-material'
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'

import { EtaSourceTooltip } from 'components/common'
import { calculateDeliveryWindow } from 'constants/TrackingMap'
import { BookingAddressType } from 'generated/graphql'

import { IOrderableAddressListItem } from './MapWithReorder'

const getItemStyle = (isDragging, draggableStyle) => ({
  // Styles we need to apply on draggable
  ...draggableStyle,

  ...(isDragging && {
    background: 'rgb(235,235,235)',
  }),
})

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getListStyle = (isDraggingOver) => ({
  // background: isDraggingOver ? 'lightblue' : 'lightgrey',
})

interface IProps {
  items: IOrderableAddressListItem[]
  disabled?: boolean
  readOnly?: boolean
  onDragEnd: any
}

const DraggableAddresses = (props: IProps) => {
  const { items, disabled = false, readOnly = false, onDragEnd } = props

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId='droppable'>
        {(provided, snapshot) => (
          <div ref={provided.innerRef}>
            <List style={getListStyle(snapshot.isDraggingOver)}>
              {items.map((item, index) => (
                <Draggable
                  key={item.id}
                  draggableId={item.id}
                  index={index}
                  isDragDisabled={disabled || readOnly || !!item.isLocked}>
                  {(provided, snapshot) => (
                    <div ref={provided.innerRef}>
                      <ListItem
                        // @ts-ignore
                        ContainerComponent='li'
                        // ContainerProps={{ ref: provided.innerRef }}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                        disabled={disabled}>
                        <ListItemIcon>
                          <Room />
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Box>
                              <Typography component='span' variant='body2'>
                                {`${item.name} (${item.letter})`}
                              </Typography>
                              {item.bookingAddressType === BookingAddressType.Delivery && (
                                <Typography
                                  component='div'
                                  sx={{
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    color: '#2c2c54',
                                    mt: 0.25,
                                  }}>
                                  <EtaSourceTooltip
                                    source={item.etaSource}
                                    lastUpdatedAt={item.etaLastUpdatedAt}
                                    hasValue={!!(item.nextAddressETA && item.etaWindowMinutes)}>
                                    {item.nextAddressETA && item.etaWindowMinutes
                                      ? `ETA: ${
                                          calculateDeliveryWindow(
                                            item.nextAddressETA,
                                            item.etaWindowMinutes,
                                          ).timeRange
                                        }`
                                      : 'ETA not available'}
                                  </EtaSourceTooltip>
                                </Typography>
                              )}
                            </Box>
                          }
                          secondary={item.description}
                        />
                        {!readOnly && (
                          <ListItemIcon style={{ minWidth: '10px' }}>
                            <Height />
                          </ListItemIcon>
                        )}
                      </ListItem>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </List>
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}

export default DraggableAddresses
